export default "__VITE_ASSET__XknXXTLexZfe83M8xxoHgg__"